import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import Location from './Components/Location/Location'
import { Plann3rStore } from '../../../../store/types'
import { Company, MeetingPageFieldType } from '../../../../types/plann3r'
import Theme from './Components/Theme/Theme'
import Logo from './Components/Logo/Logo'
import Heading from './Components/Heading/Heading'
import MeetingPageFields from './Components/MeetingPageFields/MeetingPageFields'
import Durations from './Components/Durations/Durations'
import CTA from './Components/CTA/CTA'
import Outro from './Components/Outro/Outro'

const Editor: FC = () => {
  // REDUX STORE
  const { languages, pagesManagement } = useSelector((state: Plann3rStore) => state)
  const { isFetching } = pagesManagement
  const strings = languages.strings.pages.editor

  /**
     * Returns the current page
     *
     * @returns {T|null}
     */
  const getPage = () => {
    if (pagesManagement.active_company && pagesManagement.active_page) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return pagesManagement.companies.find((company: Company) => {
        return company.id === pagesManagement.active_company
      }).pages.find((page) => page.id === pagesManagement.active_page)
    }

    return null
  }

  // Used constants
  const page = getPage()
  const durationField = page?.fields.find((field) => field.type === MeetingPageFieldType.DURATION)

  return (
    <>
      { isFetching ?
        <div>
          <p>{strings.fetching}</p>
        </div>
        :
        <div className="editor">
          { page &&
          <>
            <Theme strings={ strings } colors={ page.colors } />
            <hr />

            <Logo strings={ strings } />
            <hr />

            <Heading strings={ strings } page={ page } />
            <hr />

            <MeetingPageFields strings={ strings } fields={ page.fields } />
            <hr />

            <Location strings={ strings } location={ page.location } />
            <hr />

            { durationField && 
              <>
                <Durations strings={ strings } field={ durationField } />
                <hr />
              </>
            }
            
            <CTA strings={ strings } copy={ page.copy } />
            <hr />

            <Outro strings={ strings } copy={ page.copy } />
          </>
          }
        </div>
      }
    </>
  )
}

export default Editor